import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import en from './locales/en'
import pt from './locales/pt'

// const cspnonce = import.meta.env.VITE_CSPNONCE

Vue.use(
    Vuetify,
    // { cspNonce: cspnonce}
)

export default new Vuetify({
    lang: {
        current: 'pt',
        locales: { en, pt },
    },
    theme: {
        // options: { customProperties: true, cspNonce: cspnonce },
        themes: {
            dark: false,
            light: {},
        },
    },
})
